import { useState } from "react";

import { useMediaQuery, useTheme } from "@mui/material";

import { layoutPreferencesStorage } from "../utils/layout-preferences-storage/LayoutPreferencesStorage";
import { LayoutPreferenceKey } from "../utils/layout-preferences-storage/LayoutPreferencesStorage.types";

export const NAVIGATION_FULL_WIDTH = 305;
export const NAVIGATION_MINIMIZED_WIDTH = 60;

/**
 * Collapse state of the app sidebar: persisted in localStorage, defaulting to collapsed on small
 * screens. Shared by both app shells so the sidebars size and behave identically.
 */
export function useNavigationCollapse() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));

  const [isNavigationCollapsed, setIsNavigationCollapsed] = useState<boolean>(
    () => layoutPreferencesStorage.get(LayoutPreferenceKey.NavigationCollapsed) ?? isSmallScreen
  );

  const handleNavigationCollapse = (collapsed: boolean) => {
    setIsNavigationCollapsed(collapsed);
    layoutPreferencesStorage.set(LayoutPreferenceKey.NavigationCollapsed, collapsed);
  };

  const navigationWidth = isNavigationCollapsed ? NAVIGATION_MINIMIZED_WIDTH : NAVIGATION_FULL_WIDTH;

  return { isNavigationCollapsed, handleNavigationCollapse, navigationWidth };
}
